var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-home"},[_vm._v("欢迎使用管理后台。")])}
var staticRenderFns = []

export { render, staticRenderFns }